import React from 'react';
import { Form, Input } from 'antd';

const { TextArea } = Input;

const TextField = ({
  label,
  name,
  options = {},
  getFieldDecorator,
  inputProps,
  isTextArea = false,
  colon = false,
  ...props
}) => {
  return (
    <Form.Item {...props} label={label} colon={colon}>
      {getFieldDecorator(
        name,
        options
      )(isTextArea ? <TextArea {...inputProps} /> : <Input {...inputProps} />)}
    </Form.Item>
  );
};

export default TextField;
